import React, { Fragment, useEffect } from "react";

import { useParams } from "react-router";
import Helmet from "react-helmet";
const ARTICLEDATA = [
    {
        id: "1",
        title: "چگونه درامد بیشترداشته باشیم",
        desctiption1: "به عنوان یک فریلنسر، دانستن این موضوع که روی یک پروژه چقدر قیمت بگذارید می‌تواند حسی مانند شرط بندی باشد.",
        description: "برنامه نویس بودن می تواند برای هر کسی فوق العاده باشد. در این شغل نه تنها شما اکثر مواقع سرگرم هستید بلکه فرصت های شغلی زیادی برای شما وجود دارد که اکثر آنها نیز دارای حقوق و درآمد بالایی هستند. با این حال برخی از مواقع ممکن است شما نیاز به درآمد بیشتری داشته باشید. ممکن است شما در دوران تحصیل خود باشید و به جای این که در یک شرکت استخدام شوید علاقه مند هستید تا به عنوان یک برنامه نویس برای خودتان کار کنید یا این که ممکن است یک فرزند داشته باشید و علاقه مند باشید تا زمان بیشتری را با او بگذرانید و به همین علت نمی توانید در شرکت ها کار کنید و باید برای خودتان کار کنید. شما به عنوان یک برنامه نویس هرآنچه که برای افزایش درآمد نیاز دارید را در اختیار دارید. مغزتان، لپ تاپ و اینترنت تنها چیزهایی هستند که شما به آنها نیاز دارید. برای افزایش درآمد برنامه نویسی می توانید استراتژی هایی که در ادامه بیان می کنیم را بررسی کنید تا متوجه شوید که کدام یک می توانند برای شما گزینه بهتری باشند.",
        image: "images/course9.jpg"
    },
    {
        id: "2",
        title: "نکاتی برای ساخت نمونه کارهای عالی ",
        desctiption1: "هنگام درخواست کار، شرکت‌ها نگاهی به نمونه کارهای شما دارند. حتی اگر به صورت فریلنسری هم کار می‌کنید مشتری شما دوست ",
        description: "به عنوان یک توسعه دهنده می‌توانید به صورت فریلنسر کار کنید. اگر دانشجو هستید، به درآمدزایی شما کمک می‌کند و به شما در ارتقاء مهارت‌هایتان کمک می‌کند. با پروژه‌های کوچک شروع کنید، آن‌ها را به درستی انجام دهید. پس از اطمینان کافی از خود، به ساخت پروژه‌هایی در حد متوسط و پیشرفته بپردازید. فریلنسرینگ قطعا به نمونه کارهای شما ارزش می‌دهد. پروژه‌هایی که به عنوان فریلنسر ساخته شده‌اند، اعتماد به نفس و تخصص شما در آن مهارت را نشان می‌دهد.",
        image: "images/course6.jpg"
    },
    {
        id: "3",
        title: "چگونه یک توسعه دهنده پر بازده باقی بمانیم",
        desctiption1: "شما چه در حال حاضر یک توسعه دهنده باتجربه باشید یا تازه شروع به کار کرده باشید، اگر می‌خواهید در این صنعت واقعا موفق باشید،",
        description: "شما باید نه گفتن را به عنوان یک توسعه دهنده بیاموزید. بله گفتن به برخی از افراد در برخی از موارد به خصوص زمانی که شخص درخواست کننده را از نظر اجتماعی می شناسید کار نادرستی است. اگر مراقب این مسئله نباشید این کار می تواند به میزان زیادی روی بهره وری شما تاثیرگذار باشد. گاهی اوقات انجام کارهای کمتر بسیار کارآمدتر از زمانی است که حجم زیادی از کارها را با عجله انجام دهید. زمانی که کارها را با عجله انجام دهید نسبت به مهلت اتمام پروژه ها عقب می افتید و این مسئله می تواند به میزان زیادی باعث خسته شدن شما شود. بنابراین شما باید یاد بگیرید که چگونه نه بگویید. این کار به شما کمک می کند تا پیشاپیش درباره برنامه ها و اولویت های خود تصمیم گیری کنید و به شکل بهتری آنها را سازماندهی کنید.",
        image: "images/im4.jpg"

    },


];

const Article = () => {
    const { idarticle } = useParams();


    const found = ARTICLEDATA.find(id => id.id === idarticle);


    return (
        <Fragment>
            <section className="term-content">
                <header>
                    <h1>{found.title}</h1>
                </header>
                <Helmet>
                    <title>
                        {found.title}
                    </title>
                </Helmet>
                <div className="row">
                    <div className="col-md-8 col-sm-12 col-xs-12 pull-left">
                        <section className="term-description">
                            <img
                                src={`../${found.image}`}
                            />

                            <p>{found.description}</p>


                        </section>

                        <section className="user-comments">
                            <header>
                                <h3> نظرات کاربران </h3>
                            </header>
                            <div className="inner">
                                <form>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="نام و نام خانوادگی"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="ایمیل"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="شماره تماس"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-8 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <textarea
                                                    className="form-control"
                                                    placeholder="متن نظر"
                                                ></textarea>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8 col-sm-7 col-xs-7">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="کد امنیتی"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-5 col-xs-5">
                                                    <img src="../images/captcha.jpg" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                            >
                                                {" "}
                                                ثبت دیدگاه{" "}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <div className="comment-list">
                                    <div className="comment-row">
                                        <img src="../images/pic/avatar.jpg" />
                                        <div className="left-col">
                                            <h3> میترا رحیمی </h3>
                                            <span>12/03/1397</span>
                                            <p>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ و با
                                                استفاده از طراحان گرافیک است.
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است
                                            </p>
                                        </div>
                                    </div>

                                    <div className="comment-row">
                                        <img src="../images/pic/avatar.jpg" />
                                        <div className="left-col">
                                            <h3> میترا رحیمی </h3>
                                            <span>12/03/1397</span>
                                            <p>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ و با
                                                استفاده از طراحان گرافیک است.
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است
                                            </p>
                                        </div>
                                    </div>

                                    <div className="comment-row">
                                        <img src="../images/pic/avatar.jpg" />
                                        <div className="left-col">
                                            <h3> میترا رحیمی </h3>
                                            <span>12/03/1397</span>
                                            <p>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ و با
                                                استفاده از طراحان گرافیک است.
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است
                                            </p>
                                        </div>
                                    </div>

                                    <div className="comment-row">
                                        <img src="../images/pic/avatar.jpg" />
                                        <div className="left-col">
                                            <h3> میترا رحیمی </h3>
                                            <span>12/03/1397</span>
                                            <p>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ و با
                                                استفاده از طراحان گرافیک است.
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است
                                            </p>
                                        </div>
                                    </div>

                                    <div className="comment-row">
                                        <img src="../images/pic/avatar.jpg" />
                                        <div className="left-col">
                                            <h3> میترا رحیمی </h3>
                                            <span>12/03/1397</span>
                                            <p>
                                                لورم ایپسوم متن ساختگی با تولید
                                                سادگی نامفهوم از صنعت چاپ و با
                                                استفاده از طراحان گرافیک است.
                                                چاپگرها و متون بلکه روزنامه و
                                                مجله در ستون و سطرآنچنان که لازم
                                                است
                                            </p>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>

                    <aside className="col-md-4 col-sm-12 col-xs-12 pull-right">


                        <article className="teacher-info">
                            <img src="../images/pic/avatar.jpg" />

                            <p>
                                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                                صنعت چاپ و با استفاده از طراحان گرافیک است
                                استفاده از طراحان گرافیک است ...
                            </p>
                        </article>

                        <article className="term-info">
                            <h2> اطلاعات این دوره </h2>
                            <ul>
                                <li>سطح دوره: پیشرفته</li>
                                <li>وضعیت دوره: در حال برگزاری</li>
                                <li>قیمت : 450,000 تومان</li>
                                <li>
                                    تاریخ ثبت این دوره : چهار شنبه ۲۱ شهریور
                                    ۱۳۹۷
                                </li>
                                <li>
                                    آخرین بروزرسانی دوره : چهار شنبه ۲۱ شهریور
                                    ۱۳۹۷
                                </li>
                            </ul>
                        </article>

                        <div className="share-layer">
                            <span> به اشتراک گذاری </span>
                            <a href="">
                                <i className="zmdi zmdi-facebook"></i>
                            </a>
                            <a href="">
                                <i className="zmdi zmdi-google-old"></i>
                            </a>
                            <a href="">
                                <i className="zmdi zmdi-twitter"></i>
                            </a>
                            <a href="">
                                <i className="zmdi zmdi-linkedin"></i>
                            </a>
                        </div>

                        <div className="tags-layer">
                            <a href=""> ربات تلگرام </a>
                            <a href=""> ساخت ربات </a>
                            <a href=""> برنامه نویسی ربات </a>
                            <a href=""> کدنویسی ربات </a>
                            <a href=""> ربات تلگرام </a>
                            <a href=""> ساخت ربات </a>
                            <a href=""> برنامه نویسی ربات </a>
                            <a href=""> کدنویسی ربات </a>
                        </div>
                    </aside>
                </div>
            </section>
        </Fragment>
    );
};

export default Article;
